/* -disable react/style-prop-object */
import React, { Component } from 'react';
import { connect } from 'react-redux';

// 3rd party
import { FormattedNumber } from 'react-intl';

// Components
import EmptyState from '../../../../../components/EmptyState';
import Button from '../../../../../components/Button';
import RadioGroup, { Radio } from '../../../../../components/RadioGroup';
import AddNFPanel from './AddNFPanel';
import UnloadNFTable from './UnloadNFTable';
import BottomBar from '../../../components/BottomBar';
import SubHeader from '../../../../../components/SubHeader';
import SideMenu from '../components/SideMenu';

// Action Creators + Thunks
import {
  unloadAddNfToList,
  unloadChangeType,
  unloadRemoveNfFromList,
  unloadEditDamagedNf,
  unloadEditPalletizedNf,
  nextStep,
  changeStep,
} from '../../../../../redux/new-schedule';
import { unloadTypes, unloadTypesToLabel } from '../../../util/scheduling';

// css
import './styles.css';

class NewUnloadSchedule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newNfFormIsVisible: false,
    };
  }

  componentDidMount() {
    if (this.props.currentStep !== 2)
      this.props.dispatch(changeStep(this.props.currentStep));
  }

  _showNewNfForm = () => {
    this.setState({
      newNfFormIsVisible: true,
    });
  };

  _hideNewNfForm = () => {
    this.setState({
      newNfFormIsVisible: false,
    });
  };

  _onNewNF = values => {
    this.props.dispatch(unloadAddNfToList(values));

    if (!values.shouldAddAnother) {
      this._hideNewNfForm();
    }
  };

  _changeUnloadType = newUnloadType => {
    this.props.dispatch(unloadChangeType(newUnloadType));
  };

  _removeNfFromList = nfIndex => {
    this.props.dispatch(unloadRemoveNfFromList(nfIndex));
  };

  _updateDamagedNf = nfIndex => {
    this.props.dispatch(unloadEditDamagedNf(nfIndex));
  };

  _updatePalletizedNf = nfIndex => {
    this.props.dispatch(unloadEditPalletizedNf(nfIndex));
  };

  _submitNfSelection = () => {
    this.props.dispatch(nextStep(3));
  };

  _getLabelById = id =>
    this.props.packagingTypes.filter(v => v.id === id)[0].value;

  render() {
    const { nfList, activeUnloadType, match, history } = this.props;

    return (
      <div className="NewUnloadSchedule">
        <SubHeader
          title="Agendar"
          renderSide={() => <SideMenu match={match} history={history} />}
        />

        {/* ================================ */}
        {/* empty state                      */}
        {/* ================================ */}
        {nfList.length === 0 && (
          <EmptyState
            className="NewUnloadSchedule__empty-state"
            message="Nenhuma nota fiscal cadastrada para esta descarga. Clique no botão abaixo para cadastrar sua primeira nota fiscal."
          >
            <Button
              className="NewUnloadSchedule__empty-state-btn"
              skin="primary"
              text="Adicionar Nota Fiscal"
              icon="doc"
              onClick={this._showNewNfForm}
            />
          </EmptyState>
        )}

        {/* ================================ */}
        {/* normal state                     */}
        {/* ================================ */}
        {nfList.length > 0 && (
          <div>
            <div className="NewUnloadSchedule__toolbar">
              <div className="NewUnloadSchedule__type-selection">
                Tipo de Descarga:
                <RadioGroup
                  className="NewUnloadSchedule__type-selection-radio-group"
                  value={activeUnloadType}
                  onChangeValue={this._changeUnloadType}
                >
                  <Radio
                    className="NewUnloadSchedule__type-selection-radio"
                    value={unloadTypes.UNLOAD_RETURN}
                    label={unloadTypesToLabel[unloadTypes.UNLOAD_RETURN]}
                  />
                  <Radio
                    className="NewUnloadSchedule__type-selection-radio"
                    value={unloadTypes.UNLOAD_DELIVERY}
                    label={unloadTypesToLabel[unloadTypes.UNLOAD_DELIVERY]}
                  />
                </RadioGroup>
              </div>
              <div className="NewUnloadSchedule__add-new-nf">
                <Button
                  skin="primary"
                  text="Adicionar Nota Fiscal"
                  icon="doc"
                  onClick={this._showNewNfForm}
                />
              </div>
            </div>
            <UnloadNFTable
              data={nfList}
              onDelete={this._removeNfFromList}
              onDamagedChange={this._updateDamagedNf}
              onPalletizedChange={this._updatePalletizedNf}
              getLabelById={this._getLabelById}
            />
          </div>
        )}

        {/* ================================ */}
        {/* totalizer                        */}
        {/* ================================ */}
        {nfList.length > 0 && (
          <BottomBar>
            <div className="NewUnloadSchedule__totalizer">
              <div className="NewUnloadSchedule__totalizer-nf-count">
                <span className="NewUnloadSchedule__totalizer-nf-count-number">
                  {nfList.length}
                </span>
                NF{nfList.length !== 1 ? 's' : ''} adicionada
                {nfList.length !== 1 ? 's' : ''}
              </div>

              <div className="NewUnloadSchedule__totalizer-counter">
                Total Volumes <br />
                <strong>
                  {nfList.reduce(
                    (prev, curr) =>
                      parseFloat(prev, 10) + parseFloat(curr.volume, 10),
                    0,
                  )}
                </strong>
              </div>

              <div className="NewUnloadSchedule__totalizer-counter">
                Peso Total <br />
                <strong>
                  <FormattedNumber
                    value={nfList.reduce(
                      (prev, curr) =>
                        parseFloat(prev, 10) + parseFloat(curr.weight, 10),
                      0,
                    )}
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                  />{' '}
                  kg
                </strong>
              </div>

              <div className="NewUnloadSchedule__totalizer-counter">
                Valor Total <br />
                <strong>
                  <FormattedNumber
                    value={nfList.reduce(
                      (prev, curr) =>
                        parseFloat(prev, 10) + parseFloat(curr.value, 10),
                      0,
                    )}
                    style="currency"
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                    currency="BRL"
                    currencyDisplay="symbol"
                  />
                </strong>
              </div>

              <div className="NewUnloadSchedule__totalizer-counter">
                Com Avaria <br />
                <strong>
                  {nfList.reduce(
                    (prev, curr) => (curr.isDamaged ? prev + 1 : prev),
                    0,
                  )}{' '}
                  NFs
                </strong>
              </div>

              <div className="NewUnloadSchedule__totalizer-counter">
                Palletizadas <br />
                <strong>
                  {nfList.reduce(
                    (prev, curr) => (curr.isPalletized ? prev + 1 : prev),
                    0,
                  )}{' '}
                  NFs
                </strong>
              </div>

              <div className="NewUnloadSchedule__totalizer-counter">
                Tipo de Descarga <br />
                <strong>
                  {unloadTypes.UNLOAD_RETURN === activeUnloadType &&
                    'Devolução'}
                  {unloadTypes.UNLOAD_DELIVERY === activeUnloadType &&
                    'Entrega'}
                  {activeUnloadType === null && 'N/A'}
                </strong>
              </div>

              <div className="NewUnloadSchedule__totalizer-btn">
                <Button
                  skin="secondary"
                  text="Prosseguir"
                  disabled={activeUnloadType === null}
                  onClick={this._submitNfSelection}
                  block
                />
              </div>
            </div>
          </BottomBar>
        )}

        {/* ================================ */}
        {/* add nf panel                     */}
        {/* ================================ */}
        {this.state.newNfFormIsVisible && (
          <AddNFPanel onDismiss={this._hideNewNfForm} onNewNF={this._onNewNF} />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    nfList: state.newSchedule.unloadSchedule.nfList,
    activeUnloadType: state.newSchedule.unloadSchedule.unloadType,
    currentStep: state.newSchedule.currentStep,
    packagingTypes: state.newSchedule.packagingTypes.list,
  };
}

export default connect(mapStateToProps)(NewUnloadSchedule);
